<template>
<div class="zhuces">
  <div class="denglulogo">
       <img src="../assets/head-logo.png" alt="">
     </div>
   <router-link to="/">
      <div class="cno"></div>
    </router-link>
<!-- 登录界面 -->
      <div class="zhuces-cont">
          <div class="zhuces-titles">
                 <p>欢迎注册全国铁道供电微课大赛！</p>
            </div>
       <!-- 输入内容 -->
       <div v-show="zhuces" class="zhuces-nrs">
           <p><i class="dimi">*</i> 注册身份</p>
           <!-- 身份选择 -->
    <el-select id="zhuce-sel" @change="zcsel" value-key="weid"  v-model="Selvalue" placeholder="请选择身份">
    <el-option 
      v-for="item in zhuceoptions"
      :key="item.weid"
      :label="item.label"
      :value="item"
      >
    </el-option>
  </el-select>
  <div class="kongs"></div>
            <!-- 用户名，账号，密码 -->
    <p><i class="dimi">*</i> 账户昵称</p>
       <div class="zhuce-name">
<el-input  placeholder="请输入账户昵称" v-model="psuserone" >
            </el-input> 
       </div>
          
          <div class="kong"></div>  
          <p><i class="dimi">*</i> 登录账号</p>
          <div class="zhuce-word">
<el-input  placeholder="请输入注册账号" v-model="psname" ></el-input> 
          </div>
          
   <div class="kong"></div>
          <p><i class="dimi">*</i> 登录密码</p>
          <div class="zhuce-mima">
<el-input id="denglu-psword"   placeholder="请输入账号密码" v-model="psword" show-password></el-input> 
          </div>

       </div>
       <div v-show="zhuces" class="zhuces-btnall">
         
<button @click="zcyanz()" class="zhuces-btnss">立即注册</button>

<router-link to="/denglu">
<button class="denglus-btnss">用户登录</button>
</router-link>

       </div>
<!-- 注册成功之后 -->
      <div v-show="zhuceyes" class="zhuceyes">
        
 <i class="el-icon-success"></i>  
        <span class="zhuceyes-txt">提交成功，请前往登录！</span>
        <p class="zhuceyes-pg">您已成功注册为普通用户，请
          <span @click="dl()" class="zhuceyes-btn">立即前往</span>
          登录账号
        </p>
        <div @click="dl()" class="zhuceyes-dl">
          <span>立即登录</span>
        </div>
      </div>

      </div>
</div>
</template>

<script>
import zhuce from '../css/ZhuCe.css'
import axios from "axios"
export default {
    data(){
        return{
zhuceoptions: [
        {
         weid:1,
          value: '选项1',
          label: '普通用户'
        },
        {
         weid:2,
          value: '选项2',
          label: '参赛教师'
        }
        
        ],
        Selvalue: "",
        psuserone:'',
        psword:'',
        psname:'',
        zhuces:true,
        zhuceyes:false
        }
    },
    methods:{
      // sel选择身份
    zcsel(){
      // console.log('这是注册sel',this.Selvalue);
      if (this.Selvalue.weid == 2) {
        this.$router.push({ path: '/cansaizhuce' });
      }
    },
    dl(){
      this.$router.push({path:'/denglu'})
    },
// 账号密码正则验证
   zcyanz(){
     let zctype = this.Selvalue.weid;
     let hanzi = this.psuserone;
    let psname = this.psname;
    let psword = this.psword;
if (zctype==undefined) {
          this.$message.error({
            message:'请选择账号身份',
            offset:100
          })
        }
    var patrnhz =  /^[\u4e00-\u9fa5,\a-zA-Z\d]{1,}$/;
    var patrname = /^[\d\w]{6,16}$/
    var patrnword=/^[a-zA-Z\d,\.，。]{6,16}$/;
if (!patrnhz.exec(hanzi)) {
 this.$message.error({
   message:'用户名输入错误！请输入汉字或英文',
   offset:100
 });
  return false
}else if(!patrname.exec(psname)) {
  this.$message.error({
    message:'账号输入错误！请输入6-16位的数字字母！',
    offset:100
  });
  return false 

}else if (!patrnword.exec(psword)) {
  this.$message.error({
    message:'密码输入错误！请输入6-16位数字，字母，符号组成的密码！！！',
    offset:100
  });
  return false
}


let postdata = this.$qs.stringify({
   type:zctype,  //用户类型
   username:psname,  //账号
   password:psword ,   //密码
   nickname:hanzi    //用户名
});

axios({
  method: 'post',
  url: this.$apiUrl+'/index.php/index/register',
 data: postdata
}).then(res=>{
  // console.log(res);
  if (res.data.code == 0) {
    this.$message({
      message:res.data.msg,
      offset:100
    })
  }else if (res.data.code == 1) {
    this.$message({
      message:res.data.msg,
      offset:100
    })
    this.zhuces = false;
  this.zhuceyes = true;
  setTimeout(() => {
  this.zhuces = true;
  this.zhuceyes = false;
  this.$router.push({path:'/denglu'});
  }, 1000);
  }
}).catch(error=>{
  console.log(error);
})

   }
    },
    mounted(){
      // this.zcyanz();
    }

}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/ZhuCe.vue